export default function sortRecurringDays(arr?: (number | undefined)[]) {
  return [...(arr ?? [])].filter((num): num is number => num !== undefined).sort((a, b) => a - b)
}
